import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";

export class IsRecovery extends Decision {
    public evaluate() {
        return gameState.getCurrentGame() && gameState.getCurrentGame().isRecovered ? Exit.True : Exit.False;
    }
}
